import Backend from "./Backend";
import {selectedCompanyStore} from "../store/SelectedCompany";

class EmployeeApi {

    public startUpload(lang: string, payload: any, files: string[]): Promise<string> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/employee/upload/start`, {
            lang,
            payload,
            files,
        });
    }

    public finishUpload(sessionId: string): Promise<void> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/employee/upload/${sessionId}/finish`, {});
    }
}

export const employeeApi = new EmployeeApi();